// Packages and componets
import styled from 'styled-components';
import { Button } from 'grommet';

// Helpers and utilities
import { Sizes } from '@theme/globals/sizing';
import { colors } from '@theme/globals/colors';
import { TypographySettings } from '@theme/globals/typography';

export const StyledButton: typeof Button = styled(Button)`
  /** Button base styles */
  background-color: ${colors ? colors['white'] : 'white'};
  border-color: transparent;
  border-radius: ${Sizes[16]};
  border-width: 1px;
  color: ${colors ? colors['primary-500'] : 'brand'};
  font-size: ${TypographySettings['button'].size};
  font-weight: ${TypographySettings['button'].weight};
  line-height: ${TypographySettings['button'].height};
  padding: ${Sizes[14]} ${Sizes[16]};
  &:disabled {
    opacity: 0.6;
  }
  &:hover {
    box-shadow: none;
  }

  /** Button variation styles */
  &.is-primary {
    background-color: ${colors ? colors['primary-500'] : 'brand'};
    border-color: ${colors ? colors['primary-500'] : 'brand'};
    color: ${colors ? colors['white'] : 'white'};
  }

  &.is-secondary {
    background-color: ${colors ? colors['gray-50'] : 'gray-50'};
    border-color: ${colors ? colors['gray-50'] : 'gray-50'};
    color: ${colors ? colors['black'] : 'black'};
  }

  &.is-tertiary {
    background-color: ${colors ? colors.black : 'black'};
    border-radius: ${Sizes[21]};
    color: ${colors ? colors.white : 'white'};
    font-family: ${TypographySettings['subhead-semibold'].family};
    font-weight: ${TypographySettings['subhead-semibold'].weight};
    font-size: ${TypographySettings['subhead-semibold'].size};
    padding: ${Sizes[4]} ${Sizes[21]};
  }

  &.is-dark {
    background-color: ${colors ? colors['gray-900'] : 'gray-900'};
    border-radius: ${Sizes[21]};
    color: ${colors ? colors.white : 'white'};
    padding: ${Sizes[14]} ${Sizes[4]};
  }

  &.is-warning {
    background-color: ${colors ? colors['dk-red-light'] : 'red'};
    border-color: ${colors ? colors['dk-red-light'] : 'red'};
    color: ${colors ? colors['dk-red'] : 'dk-red'};
  }

  &.is-border {
    font-family: ${TypographySettings['footnote-semibold'].family};
    font-size: ${TypographySettings['footnote-semibold'].size};
    font-weight: ${TypographySettings['footnote-semibold'].weight};
    line-height: ${TypographySettings['footnote-semibold'].height};
    border: ${Sizes[1]} solid ${colors ? colors['primary-500'] : 'brand'};
    padding: ${Sizes[8]} ${Sizes[16]};
  }

  /** Button options */
  &.is-pill {
    border-radius: ${Sizes[99]};
  }

  &.has-icon {
    & > div {
      column-gap: 2px;
    }
  }
`;
